import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {UserAutocompleteModule} from '../../../core/user-autocomplete/user-autocomplete.module';
import {UserAssignModalComponent} from './user-assign-modal.component';

@NgModule({
  imports: UserAssignModalModule.IMPORTS,
  declarations: UserAssignModalModule.DECLARATIONS,
  exports: UserAssignModalModule.DECLARATIONS
})
export class UserAssignModalModule {
  public static readonly IMPORTS = [
    CommonModule,
    MatButtonModule,
    UserAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule
  ];

  public static readonly DECLARATIONS = [UserAssignModalComponent];
}
